"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IComponentFunctionClassParametersSchema = void 0;
const zod_1 = require("zod");
exports.IComponentFunctionClassParametersSchema = zod_1.z.record(zod_1.z.string(), zod_1.z.union([
    zod_1.z.string(),
    zod_1.z.boolean(),
    zod_1.z.number(),
    zod_1.z.any().refine((v) => typeof v === 'object' || typeof v === 'function', {
        message: 'Expected an object',
    }),
    zod_1.z.undefined(),
]));
//# sourceMappingURL=IComponentFunctionClassParameters.js.map